import { createEntityAdapter } from '@reduxjs/toolkit'

import { soyshareApi } from '../../../../../services/api'
import { savingMessagesNotification } from '../helpers/messages'

const adapter = createEntityAdapter({
  selectId: (option) => option.id,
  sortComparer: (a, b) => a.description.toLocaleString().localeCompare(b.description.toLocaleString())
})

const initialState = adapter.getInitialState()

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getSelectOptions: build.query({
      query: ({ fieldId }) => ({ url: `/form-fields/select-options/${fieldId}` }),
      providesTags: ['select-options'],
      transformResponse: (response) => adapter.setAll(initialState, response)
    }),

    createSelectOption: build.mutation({
      query: ({ fieldId, payload }) => ({
        url: `/form-fields/select-options/${fieldId}`,
        method: 'POST',
        body: payload
      }),
      onQueryStarted: async ({ fieldId }, { dispatch, queryFulfilled }) => {
        savingMessagesNotification.saving()
        const { data } = await queryFulfilled
        dispatch(api.util.updateQueryData('getSelectOptions', { fieldId }, (draft) => adapter.addOne(draft, data)))
        savingMessagesNotification.success()
      }
    }),

    updateSelectOption: build.mutation({
      query: ({ payload }) => ({
        url: `/form-fields/select-options/${payload.id}`,
        method: 'PATCH',
        body: payload
      }),
      onQueryStarted: async ({ payload, fieldId }, { dispatch, queryFulfilled }) => {
        savingMessagesNotification.saving()
        const patchResult = dispatch(
          api.util.updateQueryData('getSelectOptions', { fieldId }, (draft) =>
            adapter.updateOne(draft, {
              id: payload.id,
              changes: payload
            })
          )
        )
        queryFulfilled.then(() => savingMessagesNotification.success()).catch(patchResult.undo)
      }
    }),

    removeSelectOption: build.mutation({
      query: ({ optionId }) => ({
        url: `/form-fields/select-options/${optionId}`,
        method: 'DELETE'
      }),
      onQueryStarted: async ({ fieldId, optionId }, { dispatch, queryFulfilled }) => {
        savingMessagesNotification.saving()
        const patchResult = dispatch(
          api.util.updateQueryData('getSelectOptions', { fieldId }, (draft) => adapter.removeOne(draft, optionId))
        )
        queryFulfilled.then(() => savingMessagesNotification.success()).catch(patchResult.undo)
      }
    })
  })
})

export const {
  useGetSelectOptionsQuery,
  useCreateSelectOptionMutation,
  useUpdateSelectOptionMutation,
  useRemoveSelectOptionMutation
} = api
